import React from 'react'

const Direct = () => {
    return (
            <div className="mainside">
        <div className="container">
        <div>
            Direct
        </div>
        </div>
        </div>
    )
}

export default Direct
